import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FloatLabel } from 'primeng/floatlabel';
import { Skeleton } from 'primeng/skeleton';
import { InputDropdownSelectorInterface } from '../../../types/interfaces/input.interface';
import { TranslateSafePipe } from '../../pipes/translation.pipe';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

@Component({
  selector: 'app-dropdown-selector',
  imports: [
    AutoCompleteModule,
    ReactiveFormsModule,
    FloatLabel,
    Skeleton,
    TranslateSafePipe,
  ],
  templateUrl: './dropdown-selector.html',
  styleUrls: [
    '../../styles/input-base.css',
    './dropdown-selector.css',
  ],
})
export class DropdownSelector {
  @Input()
  public formData!: InputDropdownSelectorInterface;

  @Input()
  public isLoading: boolean = false;

  public filteredSuggestions: string[] = [];

  public search(event: AutoCompleteCompleteEvent): void {
    const query: string = event.query?.toLowerCase()
      .trim() ?? '';
    const suggestions: string[] = this.formData.suggestions ?? [];

    if (!query) {
      this.filteredSuggestions = [...suggestions];
      return;
    }

    this.filteredSuggestions = suggestions.filter((item: string) =>
      item.toLowerCase()
        .includes(query),
    );
  }
}
